// -------------------------------------Working ----------------------------
import React, { useState } from "react";
import am from "../../assets/img/orders/am.png";
import pm from "../../assets/img/orders/pm.png";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

const formatDate = (date) => {
  const options = { day: "2-digit", month: "short" };
  return date.toLocaleDateString("en-US", options);
};

// Helper function to get next n days
const getNextDays = (n) => {
  const days = [];
  const dates = [];
  for (let i = 0; i < n; i++) {
    const date = new Date();
    date.setDate(date.getDate() + i);
    days.push(date.toLocaleDateString("en-US", { weekday: "short" }));
    dates.push(formatDate(date));
  }
  return { days, dates };
};

// Helper function to generate time slots
const generateTimeSlots = (selectedPeriod) => {
  const slots = [];
  const currentTime = new Date();
  const startHour = currentTime.getHours(); // Get current hour

  let startAmHour = 0; // Start hour for AM slots
  let endAmHour = 11; // End hour for AM slots
  let startPmHour = 12; // Start hour for PM slots
  let endPmHour = 23; // End hour for PM slots

  if (selectedPeriod === "AM") {
    // Generate 12-hour slots for AM period
    for (let hour = startAmHour; hour <= endAmHour; hour += 2) {
      const startTime = new Date(currentTime); // Create new date object for start time
      startTime.setHours(hour, 0, 0, 0); // Set hours and reset minutes and seconds

      const endTime = new Date(startTime); // Create new date object for end time
      endTime.setHours(hour + 2, 0, 0, 0); // Set end hours and reset minutes and seconds

      slots.push({
        start: startTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
        end: endTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
    }
  } else if (selectedPeriod === "PM") {
    // Generate 12-hour slots for PM period
    for (let hour = startPmHour; hour <= endPmHour; hour += 2) {
      const startTime = new Date(currentTime); // Create new date object for start time
      startTime.setHours(hour, 0, 0, 0); // Set hours and reset minutes and seconds

      const endTime = new Date(startTime); // Create new date object for end time
      endTime.setHours(hour + 2, 0, 0, 0); // Set end hours and reset minutes and seconds

      slots.push({
        start: startTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
        end: endTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
    }
  } else {
    // If no period is selected, show all 24-hour slots
    for (let hour = 0; hour < 24; hour += 2) {
      const startTime = new Date(currentTime); // Create new date object for start time
      startTime.setHours(hour, 0, 0, 0); // Set hours and reset minutes and seconds

      const endTime = new Date(startTime); // Create new date object for end time
      endTime.setHours(hour + 2, 0, 0, 0); // Set end hours and reset minutes and seconds

      slots.push({
        start: startTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
        end: endTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
    }
  }

  return slots;
};
// const generateTimeSlots = (selectedPeriod) => {
//   const slots = [];
//   const currentTime = new Date();

//   // Calculate the initial start time
//   let startTime = new Date(currentTime);
//   startTime.setMinutes(Math.ceil(startTime.getMinutes() / 120) * 120); // Round up to the next 2-hour slot
//   startTime.setSeconds(0);
//   startTime.setMilliseconds(0);

//   // Define the range of hours based on AM or PM
//   const startHour = selectedPeriod === "AM" ? 0 : 12;
//   const endHour = selectedPeriod === "AM" ? 11 : 23;

//   // Generate slots
//   for (let hour = startHour; hour <= endHour; hour += 2) {
//     const slotStartTime = new Date(startTime);
//     slotStartTime.setHours(hour, 0, 0, 0);

//     const slotEndTime = new Date(slotStartTime);
//     slotEndTime.setHours(hour + 2, 0, 0, 0);

//     // Ensure slot start time is not before current time
//     if (slotStartTime >= currentTime) {
//       slots.push({
//         start: slotStartTime.toLocaleTimeString("en-US", {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         end: slotEndTime.toLocaleTimeString("en-US", {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//       });
//     }
//   }

//   return slots;
// };

const CalendarSlot = ({ onConfirm }) => {
  const { days, dates } = getNextDays(5);

  const [selectedDay, setSelectedDay] = useState(days[0]);
  const [selectedTime, setSelectedTime] = useState("AM");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [deliveryTime, setDeliveryTime] = useState(null);
const {t} = useTranslation();

  const times = generateTimeSlots(selectedTime); // Generate time slots based on selectedTime (AM or PM)

  const handleConfirm = () => {
    if (selectedSlot) {
      const [startTime, endTime] = selectedSlot.split(" - ");
      const selectedDate = dates[days.indexOf(selectedDay)];
      const combinedFromDateTime = new Date(
        `${new Date().getFullYear()}-${selectedDate.split(" ")[1]}-${
          selectedDate.split(" ")[0]
        }T${startTime}`
      );
      const combinedToDateTime = new Date(
        `${new Date().getFullYear()}-${selectedDate.split(" ")[1]}-${
          selectedDate.split(" ")[0]
        }T${endTime}`
      );

      const deliveryTime = {
        from: Math.floor(combinedFromDateTime.getTime() / 1000),
        to: Math.floor(combinedToDateTime.getTime() / 1000),
      };
      console.log("Delivery Time:", deliveryTime);
      if (onConfirm) {
        onConfirm(deliveryTime); // Pass deliveryTime object to parent component
      }
      setDeliveryTime(deliveryTime);

      // Further logic with deliveryTime object
    }
    console.log("selectedSlot", selectedSlot);
  };

  return (
    <div className="rounded-lg bg-white p-4 shadow-md">
      <h2 className="mb-4 font-poppins text-xl font-semibold text-[#3860A4]">
        {t("Collection date & time")}
      </h2>
      <hr className="text-[#C5C5C5]" />

      <div className="mb-4">
        <h3 className="mb-2 text-lg font-medium text-[#9496AE]">{t("Delivery on")}</h3>
        <div className="flex flex-wrap space-x-2">
          {days?.map((day, index) => (
            <div
              key={day}
              className={`cursor-pointer rounded-md px-8 py-4 ${
                selectedDay === day
                  ? "btn-gradient text-white"
                  : "bg-[#9496ae17]"
              } `}
              onClick={() => setSelectedDay(day)}
            >
              {day}
              <div className="text-xs">{dates[index]}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-4">
        <div className="flex space-x-2">
          <div
            className={`cursor-pointer rounded px-4 py-2 ${
              selectedTime === "AM"
                ? "btn-gradient text-white"
                : "bg-[#9496ae17]"
            }`}
            onClick={() => setSelectedTime("AM")}
          >
            <div className="flex items-center gap-2 rounded-[100px]">
              <span>
                {selectedTime === "AM" ? (
                  <img src={am} alt="AM" />
                ) : (
                  <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.89937 7.70891C2.89937 9.99129 4.74298 11.8407 7.01702 11.8407C9.29106 11.8407 11.1347 9.99129 11.1347 7.70891C11.1347 5.42653 9.29161 3.57716 7.01702 3.57716C4.74298 3.57716 2.89937 5.42653 2.89937 7.70891ZM7.01702 0.684937L5.85914 3.00918H8.17545L7.01702 0.684937ZM11.9648 2.72712L9.50792 3.54851L11.1451 5.19185L11.9648 2.72712ZM4.52612 3.54851L2.0698 2.72712L2.88839 5.1924L4.52612 3.54851ZM2.31631 6.52943L0 7.69183L2.31631 8.85368V6.52943ZM11.6837 8.88839L14 7.72654L11.6837 6.56469V8.88839ZM7.01702 14.7329L8.1749 12.4086H5.85859L7.01702 14.7329ZM9.50792 11.8693L11.9648 12.6907L11.1456 10.2254L9.50792 11.8693ZM2.0698 12.6907L4.52612 11.8693L2.88839 10.2254L2.0698 12.6907Z"
                      fill="white"
                    />
                  </svg>
                )}
              </span>
              <p>AM</p>
            </div>
          </div>
          <div
            className={`cursor-pointer rounded px-4 py-2 ${
              selectedTime === "PM"
                ? "btn-gradient text-white"
                : "bg-[#9496ae17]"
            }`}
            onClick={() => setSelectedTime("PM")}
          >
            <div className="flex items-center gap-2 rounded-[100px]">
              <span>
                {selectedTime === "PM" ? (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.44326 13.4765C10.0016 13.9521 13.2706 11.4432 13.7446 7.87258C13.7844 7.57344 13.3441 7.46425 13.1559 7.69966C12.2608 8.81953 10.8207 9.4557 9.29915 9.25231C6.98615 8.94313 5.36093 6.81108 5.66905 4.49016C5.87175 2.96338 6.86064 1.73524 8.17208 1.16156C8.44777 1.04096 8.458 0.586036 8.15988 0.546186C4.60146 0.0705308 1.33252 2.57948 0.858487 6.15008C0.38446 9.72066 2.88484 13.0008 6.44326 13.4765Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <img src={pm} alt="PM" />
                )}
              </span>
              <p>PM</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-3">
        {times.map((slot, index) => (
          <div
            key={index}
            className={`cursor-pointer rounded-md px-4 py-2 ${
              selectedSlot === `${slot.start} - ${slot.end}`
                ? "btn-gradient text-white"
                : "bg-[#9496ae17]"
            } `}
            onClick={() => setSelectedSlot(`${slot.start} - ${slot.end}`)}
          >
            {`${slot.start} - ${slot.end}`}
          </div>
        ))}
      </div>

      <hr className="mb-3 mt-3" />

      <Button
        className="btn-gradient ml-auto mr-auto flex w-40 items-center justify-center p-5 text-[white]"
        onClick={handleConfirm}
        disabled={!selectedSlot}
      >
        Confirm
      </Button>
    </div>
  );
};

export default CalendarSlot;
